
<mat-expansion-panel>
  <mat-expansion-panel-header>
    <mat-panel-title style="color:#595c5f;">
      @if(type=='incoming'){
        <mat-icon style="margin-right: 10px;">input</mat-icon>{{'workTask.incoming_tridys' | translate}}
      }

      @if(type=='outgoing'){
        <mat-icon style="margin-right: 10px;">output</mat-icon>{{'workTask.outgoing_tridys' | translate}}
      }
    </mat-panel-title>
  </mat-expansion-panel-header>


  <mat-card class="mb-2">
    <mat-card-content class="my-2">
      @for (trdy of data; track trdy) {
        <div class="item-content incoming my-1" (click)="openDetailedView(trdy.tridyId)">
          <div class="d-flex flex-row flex-nowrap justify-content-between align-items-center">
            <div class="d-flex flex-column flex-nowrap">
              @if (getTRIDYIdData(trdy.tridyId, 'payload')) {
                <div>
                  @if (getContentTypeFieldById(trdy.contentTypeId, 'titleKey')) {
                    <div class="title-key-2">
                      {{getTitleKeyOfTridy(getTRIDYIdData(trdy.tridyId, 'payload'), getContentTypeFieldById(trdy.contentTypeId, 'titleKey'))}}
                    </div>
                  }
                  @if (getContentTypeFieldById(trdy.contentTypeId, 'subtitleKeys')) {
                    <div>
                      @for (subtitle of getSubtitleKeyOfTridy(getTRIDYIdData(trdy.tridyId, 'payload'), getContentTypeFieldById(trdy.contentTypeId, 'subtitleKeys')); track subtitle) {
                        <div>
                          @if (subtitle?.contentType === 'public.image') {
                            <div class="subtitle-key-2">{{subtitle.fileName}}</div>
                          }
                          @if (subtitle?.contentType !== 'public.image') {
                            <div class="subtitle-key-2">{{subtitle}}</div>
                          }
                        </div>
                      }
                    </div>
                  }
                  @if (!getContentTypeFieldById(trdy.contentTypeId, 'titleKey') && !getContentTypeFieldById(trdy.contentTypeId, 'subtitleKeys')) {
                    <span class="title-key-2">
                      {{getContentTypeFieldById(trdy.contentTypeId, 'displayName')}}
                    </span>
                  }
                </div>
              }
              @if (!getTRIDYIdData(trdy.tridyId, 'payload')) {
                <div>
                  <span class="title-key-2">
                    {{getContentTypeFieldById(trdy.contentTypeId, 'displayName')}}
                  </span>
                </div>
              }
              <div class="mt-1">ID: {{trdy.tridyId}}</div>
              <div class="d-flex flex-column text-muted">
                @if (getTRIDYIdData(trdy.tridyId, 'creationDate')) {
                  <span>
                    {{'creation_date' | translate}}: {{getTRIDYIdData(trdy.tridyId, 'creationDate').toDate() | date:'dd.MM.yyyy, HH:mm' }}
                  </span>
                }
                @if (getTRIDYIdData(trdy.tridyId, 'timeStamp')) {
                  <span>
                    {{'last_update' | translate}}: {{getTRIDYIdData(trdy.tridyId, 'timeStamp').toDate() | date:'dd.MM.yyyy, HH:mm' }}
                  </span>
                }
              </div>
            </div>
            <!-- <span class="material-symbols-outlined" style="color:var(--warmOrange);">
            keyboard_arrow_right
          </span> -->
        </div>
      </div>
    }
  </mat-card-content>
</mat-card>

</mat-expansion-panel>
